/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react'
import debounce from 'lodash/debounce'

export const useDebouncedCallback = (callback, dependencies, delay) => {
  return useMemo(() => debounce(callback, delay), [...dependencies])
}
